import { Trans, useTranslation } from 'next-i18next';

import {
  ArrowDownIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  Button,
  ExpandableText,
} from '@catawiki/cata-style';

type FAQItemProps = {
  title: string;
  text: string;
  link: string;
};

export const FAQItem = ({ title, text, link }: FAQItemProps) => {
  const { t } = useTranslation();
  return (
    <ExpandableText
      summary={title}
      detailsClassName="u-typography-body u-p-h-l"
      summaryRenderer={({ isOpen, onClick, disabled, summary }) => (
        <header>
          <h4 className="u-p-h-l u-p-v-xs u-typography-h4">
            <Button
              disabled={disabled}
              icon={isOpen ? ArrowUpIcon : ArrowDownIcon}
              iconPosition="end"
              iconSize="m"
              color="black"
              iconColor="brand"
              iconSpacing="m"
              width="full"
              variant="secondary"
              className="tw:items-center tw:w-full"
              onClick={onClick}
            >
              {summary}
            </Button>
          </h4>
        </header>
      )}
    >
      <Trans t={t}>
        {/* eslint-disable-next-line react/no-danger */}
        <div dangerouslySetInnerHTML={{ __html: text }} />

        <Button
          as="a"
          type="button"
          variant="tertiary"
          icon={ArrowRightIcon}
          iconPosition="end"
          iconSize="xs"
          target="_blank"
          href={link}
        >
          {t('seller_register.learn_more')}
        </Button>
      </Trans>
    </ExpandableText>
  );
};
